import React, { useContext, useRef, useState } from "react";
import styled from "styled-components";
import Phone from "../images/Phone.png";
import Email from "../images/Email.png";
import Address from "../images/Address.png";
import { mobile } from "../Responsive";
import emailjs from "emailjs-com";
import { ThemeContext } from "../context";

const C = styled.div`
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CWrapper = styled.div`
  padding: 50px;
  display: flex;
  ${mobile({ flexDirection: "column", padding: "0px 50px" })}
`;
const CLeft = styled.div`
  flex: 1;
`;
const CTitle = styled.h1`
  font-size: 60px;
  width: 80%;
  ${mobile({ fontSize: "30px" })}
`;
const CInfo = styled.div``;
const CInfoItem = styled.div`
  display: flex;
  align-items: center;
  margin: 50px 0px;
  font-weight: 500;
  width: 70%;
  ${mobile({ margin: "20px 0px", width: "100%" })}
`;
const CIcon = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 20px;
`;
const CRight = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const CDesc = styled.p`
  font-weight: 200;
  ${mobile({ display: "none" })}
`;
const Form = styled.form`
  margin-top: 20px;
  ${mobile({ marginTop: "0px", display: "flex", flexWrap: "wrap" })}
`;
const Input = styled.input`
  width: 50%;
  height: 50px;
  border: none;
  border-bottom: 1px solid ${(props) => (props.dark ? "#999" : "#272727")};
  margin: 10px 0px;
  font-size: 14px;
  padding-left: 10px;
  background-color: ${(props) => props.dark && "#333"};
  &:focus {
    outline: none;
  }
  ${mobile({ width: "35%", height: "40px", margin: "10px", marginLeft: "0" })};
`;
const TextArea = styled.textarea`
  width: 100%;
  margin: 10px 0px;
  font-size: 14px;
  padding-left: 10px;
  background-color: ${(props) => props.dark && "#333"};
  &:focus {
    outline: none;
  }
`;
const Button = styled.button`
  border: none;
  padding: 15px;
  background-color: #6d0ffc;
  border-radius: 20px;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  ${mobile({ marginTop: "10px" })}
`;

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_a9n2qbd",
        "template_ba8p2s4",
        formRef.current,
        "user_5PoQMCj0Oze5dG0XwETWy"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <C>
      <CWrapper>
        <CLeft>
          <CTitle>Let's discuss your project</CTitle>
          <CInfo>
            <CInfoItem>
              <CIcon src={Phone} alt="" />
              +91 8769973256
            </CInfoItem>
            <CInfoItem>
              <CIcon src={Email} alt="" />
              gurumeena41.gm@gmail.com
            </CInfoItem>
            <CInfoItem>
              <CIcon src={Address} alt="" />
              Jaipur,Rajasthan,India
            </CInfoItem>
          </CInfo>
        </CLeft>
        <CRight>
          <CDesc>
            <b>What's your story?</b> Get in touch. Always available for
            freelancing if the right project comes along me.
          </CDesc>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Input
              dark={darkMode}
              type="text"
              placeholder="Name"
              name="user_name"
            />
            <Input
              dark={darkMode}
              type="text"
              placeholder="Subject"
              name="user_subject"
            />
            <Input
              dark={darkMode}
              type="text"
              placeholder="Email"
              name="user_email"
            />
            <TextArea
              dark={darkMode}
              rows="5"
              placeholder="Message"
              name="message"
            />
            <Button>Submit</Button>
            {done && "Thank you..."}
          </Form>
        </CRight>
      </CWrapper>
    </C>
  );
};

export default Contact;
